import $ from "jquery";

import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

import Mousetrap from "mousetrap";
import Loading from "shared/loading";
import Invoca from "shared/invoca";

Backdraft.app("Header", function(app) {
  app.view("KeyboardShortcutsIndex", {

    config: [
      {
        "Site Wide Shortcuts": [
          {
            keys: ['/'],
            description: "Go To Global Search",
            functionBinding: function () {
              Invoca.smoothScrollTo($('body'));
              $('#global_search').focus();
              return false;
            }.bind(this)
          },
          {
            keys: ['g', 'n'],
            description: "Go To Network Selector",
            functionBinding: function () {
              Invoca.smoothScrollTo($('body'));
              $('#network_list_navbar-super-duper').select2('open');
              $('.select2-search').focus();
            }.bind(this)
          },
          {
            keys: ['g', 'd'],
            description: "Go To Dashboard",
            functionBinding: function () {
              $('#nav_item_dashboard_js a')[0].click();
            }.bind(this)
          },
          {
            keys: ['g', 'm'],
            description: "Go To Reports - My Reports",
            functionBinding: function () {
              Loading.show();
              $('#nav_item_my_reports_js')[0].click();
            }.bind(this)
          },
          {
            keys: ['g', 'c'],
            description: "Go To Reports - Calls",
            functionBinding: function () {
              Loading.show();
              $('#nav_item_calls_js')[0].click();
            }.bind(this)
          },
          {
            keys: ['g', 't'],
            description: "Go To Reports - Transactions",
            functionBinding: function () {
              Loading.show();
              $('#nav_item_transactions_js')[0].click();
            }.bind(this)
          },
          {
            keys: ['g', 'e'],
            description: "Open Edit Columns modal",
            functionBinding: function () {
              $('[data-action="edit-columns"]').click();
            }.bind(this)
          },
          {
            keys: ['?'],
            description: "Show This Help Modal",
            functionBinding: null // Do not override this!
          },
          {
            keys: ['esc'],
            description: "Close Modal",
            functionBinding: function () {
              $('.modal').modal('hide');
            }.bind(this)
          }
        ]
      }, {
        "All Reports": [
          {
            keys: ['r', 'd'],
            description: "Open Date Range Selector",
            functionBinding: function () {
              $('.date-range-selector-modal-button').click();
            }.bind(this)
          },
          {
            keys: ['r', '&#8594'],
            binding: 'r right',
            description: "Paginate Next",
            functionBinding: function () {
              $('.next a').click();
            }.bind(this)
          },
          {
            keys: ['r', '&#8592'],
            binding: 'r left',
            description: "Paginate Previous",
            functionBinding: function () {
              $('.prev a').click();
            }.bind(this)
          },
        ],
      },
      {
        "Calls Report": [
          {
            keys: ['j'],
            description: "Navigate down a row",
            functionBinding: function () {
              try {
                if (Backdraft.app('Reporting').config.transactionType == "complete_call_count") {
                  var current;
                  if ($('tr.highlighted').length === 1) {
                    current = $('tr.highlighted');
                    current.removeClass('highlighted').next('tr').addClass('highlighted');
                  } else {
                    current = $('table tbody tr').eq(1);
                    current.addClass('highlighted');
                  }
                }
              } catch(e) { }
            }.bind(this)
          },
          {
            keys: ['k'],
            description: "Navigate up a row",
            functionBinding: function () {
              try {
                if (Backdraft.app('Reporting').config.transactionType == "complete_call_count") {
                  var current;
                  if ($('tr.highlighted').length === 1) {
                    current = $('tr.highlighted');
                    current.removeClass('highlighted').prev('tr').addClass('highlighted');
                  } else {
                    current = $('table tbody tr').eq($('table tbody tr').length - 1);
                    current.addClass('highlighted');
                  }
                }
              } catch(e) { }
            }.bind(this)
          },
          {
            keys: ['enter'],
            description: "Show Call Details for selected row",
            functionBinding:  function () {
              try {
                if (Backdraft.app('Reporting').config.transactionType == "complete_call_count") {
                  if ($('.highlighted').length === 1) {
                    window.location.href = $('tr.highlighted').find("[data-action=specificCallViewClick]")[0].href;
                  }
                }
              } catch(e) { }
            }.bind(this)
          }
        ],
      }

    ],

    initialize: function () {
      this._invokeModalKeyBinding();
      this._keyBindingsIfEnabled();
    },

    _invokeModalKeyBinding: function () {
      Mousetrap.bind('?', function () {
        var modal = this.child("keyboardShortcutsModal");
        modal && modal.close();
        modal = new app.Views.KeyboardShortcutsModal({ config: this.config });
        this.child("keyboardShortcutsModal", modal).render();
      }.bind(this));
    },

    _keyBindingsIfEnabled: function () {
      if (!$.cookie('disable_keyboard_shortcuts')) {
        this._setupKeyBindings();
      }
    },

    _setupKeyBindings: function () {
      _.forEach(this.config, function (section) {
        _.forEach(_.values(section)[0], function (bindingHash) {
          var keys = bindingHash.binding || bindingHash.keys.join(' ');

          if (bindingHash.functionBinding) {
            Mousetrap.bind(keys, function() {
              try {
                return bindingHash.functionBinding();
              } catch (e) {
                Loading.hide();
                throw e;
              }
            });
          }
        });
      });
    }
  });
});
